import { render, staticRenderFns } from "./milestones-full-grid.vue?vue&type=template&id=2fecdaa6&scoped=true&"
import script from "./milestones-full-grid.vue?vue&type=script&lang=ts&"
export * from "./milestones-full-grid.vue?vue&type=script&lang=ts&"
import style0 from "./milestones-full-grid.vue?vue&type=style&index=0&id=2fecdaa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fecdaa6",
  null
  
)

export default component.exports